"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionExportPolicy = void 0;
exports.CollectionExportPolicy = {
    /**
     * Maximum number of collections allowed to be exported at one time.
     *
     * Limit in place to reduce load on servers.
     */
    MAX_LIMIT: 2500
};
//# sourceMappingURL=export.js.map